import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import ReactDOM from "react-dom/client";
import { ThemeProvider as StyledThemeProvider } from "styled-components";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import theme from "./theme";

console.log("NODE_ENV", process.env.NODE_ENV);

if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.error = () => {}; // You can also disable warnings
  console.warn = () => {};
  console.info = () => {};
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <MuiThemeProvider theme={theme}>
    <StyledThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </StyledThemeProvider>
  </MuiThemeProvider>
);

reportWebVitals();
